import type { RouteRecordRaw } from 'vue-router';

import { setToken, autoLogin, logout } from '@/api/user';
const routes: RouteRecordRaw[] = [
  {
    path: '/',
    beforeEnter: async (to) => {
      // 自动登录功能
      if (to.query.username && to.query.key) {
        const res = await autoLogin({
          username: to.query.username,
          projectid: to.query.projectid,
          key: to.query.key,
        });
        if (res.data.jwt) {
          setToken(res.data.jwt);
        } else {
          logout();
          alert('签名失败');
          window.location.href = '/';
        }
      }
      return true;
    },
    component: () => import('@/views/home/index.vue'),
  },
  {
    path: '/editor',
    beforeEnter: async (to) => {
      const { token, appId, apiUrl } = to.query as { token: string; appId: string; apiUrl: string };
      localStorage.setItem('sdkToken', token);
      localStorage.setItem('sdkAppId', appId);
      localStorage.setItem('sdkApiUrl', apiUrl);
      return true;
    },
    component: () => import('@/views/editor/index.vue'),
  },
  {
    path: '/template',
    component: () => import('@/views/template/index.vue'),
  },
  // {
  //   path: '/store', // 模版商城路由
  //   component: () => import('@/views/store/index.vue'),
  // },
  // {
  //   path: '/productDetail',
  //   component: () => import('@/views/productydDetail/index.vue'), // 对应商品详情组件
  // },
  // {
  //   path: '/vipCodeGenerate',
  //   component: () => import('@/views/vipCodeGenerate/index.vue'),
  // },
  {
    path: '/user',
    redirect: '/user/info',
    component: () => import('@/views/user/index.vue'),
    children: [
      {
        path: 'info',
        component: () => import('@/views/user/content.vue'),
      },
      {
        path: 'orderList',
        component: () => import('@/views/user/components/orderList.vue'),
      },
      {
        path: 'proOrderList',
        component: () => import('@/views/user/components/proOrderList.vue'),
      },
      {
        path: 'pay',
        component: () => import('@/views/user/components/pay.vue'),
      },
      {
        path: 'userAddress',
        component: () => import('@/views/user/components/userAddress.vue'),
      },
    ],
  },
  {
    path: '/jsonTools',
    component: () => import('@/views/jsonTools/index.vue'),
  },
  {
    path: '/forget',
    component: () => import('@/views/forget/index.vue'),
  },
  {
    path: '/changePassword',
    component: () => import('@/views/changePassword/index.vue'),
  },
  {
    path: '/resetPassword',
    component: () => import('@/views/forget/resetPassword.vue'),
  },
  {
    path: '/confirmation',
    component: () => import('@/views/forget/confirmation.vue'),
  },
  {
    path: '/vip',
    component: () => import('@/views/vip/index.vue'),
  },
  {
    path: '/transfer',
    component: () => import('@/test/index.vue'),
  },

  {
    path: '/privacy',
    component: () => import('@/components/top/components/privacy.vue'),
  },
  {
    path: '/productsettlement',
    component: () => import('@/views/commoditySettlement/userAdress.vue/Productsettlement.vue'),
  },
  {
    path: '/commoditySettlement/index',
    component: () => import('@/views/commoditySettlement/index.vue'),
  },
];

export default routes;
